// All mock data — a believable regulated mid-market (bank / insurer) scenario.

export const kpis = [
  {
    id: 'hours',
    icon: 'schedule',
    tint: 'coral',
    value: 1240,
    unit: 'hrs',
    decimals: 0,
    label: 'Hours given back',
    meta: '≈ 7.2 full-time roles freed',
    trend: '+18%',
  },
  {
    id: 'docs',
    icon: 'description',
    tint: 'teal',
    value: 18400,
    unit: '',
    decimals: 0,
    label: 'Documents processed',
    meta: '99.2% straight-through, no human touch',
    trend: '+24%',
  },
  {
    id: 'exceptions',
    icon: 'verified_user',
    tint: 'lav',
    value: 2106,
    unit: '',
    decimals: 0,
    label: 'Exceptions caught',
    meta: 'Flagged before reaching downstream',
    trend: '+9%',
  },
  {
    id: 'saved',
    icon: 'savings',
    tint: 'peach',
    value: 48.2,
    unit: 'K',
    prefix: '$',
    decimals: 1,
    label: 'Cost saved this month',
    meta: 'Incl. $11K in tokens saved by smart routing',
    trend: '+31%',
  },
]

export const agents = [
  {
    id: 'docstream',
    name: 'DocStream',
    role: 'Document Intake · OCR',
    icon: 'document_scanner',
    tint: 'coral',
    status: 'live',
    job: 'Extracting & routing 42 scanned claim forms',
    progress: 0.68,
    stats: [
      { n: '42', l: 'in queue' },
      { n: '1,180', l: 'today' },
      { n: '99.4%', l: 'accuracy' },
    ],
  },
  {
    id: 'reconcile',
    name: 'Reconcile',
    role: 'Data Integrity',
    icon: 'rule',
    tint: 'teal',
    status: 'live',
    job: 'Reconciling ledger vs. core banking — 3 mismatches flagged',
    progress: 0.84,
    stats: [
      { n: '3', l: 'flagged' },
      { n: '9,420', l: 'records' },
      { n: '0', l: 'missed' },
    ],
  },
  {
    id: 'insight',
    name: 'Insight',
    role: 'Business Analyst',
    icon: 'insights',
    tint: 'lav',
    status: 'running',
    job: 'Drafting Q2 board deck from 6 connected sources',
    progress: 0.41,
    stats: [
      { n: '6', l: 'sources' },
      { n: '14', l: 'slides' },
      { n: '5 min', l: 'vs. 8 hrs' },
    ],
  },
  {
    id: 'sentinel',
    name: 'Sentinel',
    role: 'Compliance · KYC Watch',
    icon: 'shield_person',
    tint: 'peach',
    status: 'idle',
    job: 'Monitoring — next sweep scheduled in 18 min',
    progress: 1,
    stats: [
      { n: '0', l: 'alerts' },
      { n: '312', l: 'profiles' },
      { n: '12 min', l: 'last run' },
    ],
  },
]

// Seed activity — newest first. The feed prepends live events on top of these.
export const seedFeed = [
  { id: 's1', agent: 'docstream', text: 'routed invoice <b>#4471</b> → Accounts Payable', icon: 'forward_to_inbox', tint: 'coral', when: 'just now' },
  { id: 's2', agent: 'reconcile', text: 'flagged a <b>$2,140 mismatch</b> in the GL feed', icon: 'flag', tint: 'teal', when: '1 min ago' },
  { id: 's3', agent: 'insight', text: 'pulled <b>Q2 revenue</b> from the data warehouse', icon: 'insights', tint: 'lav', when: '3 min ago' },
  { id: 's4', agent: 'docstream', text: 'extracted <b>28 fields</b> from a scanned loan packet', icon: 'document_scanner', tint: 'coral', when: '6 min ago' },
  { id: 's5', agent: 'sentinel', text: 'completed a clean <b>KYC sweep</b> — 0 alerts', icon: 'verified', tint: 'peach', when: '12 min ago' },
]

// Pool of events that get prepended over time to keep the feed alive.
export const liveEvents = [
  { agent: 'docstream', text: 'routed claim <b>#8820</b> → Adjuster queue', icon: 'forward_to_inbox', tint: 'coral' },
  { agent: 'reconcile', text: 'reconciled <b>1,024 records</b> with no breaks', icon: 'rule', tint: 'teal' },
  { agent: 'insight', text: 'generated a <b>variance summary</b> for finance', icon: 'insights', tint: 'lav' },
  { agent: 'docstream', text: 'classified <b>15 documents</b> by type', icon: 'document_scanner', tint: 'coral' },
  { agent: 'sentinel', text: 'cleared <b>9 watchlist</b> matches as false positives', icon: 'shield_person', tint: 'peach' },
  { agent: 'reconcile', text: 'flagged a <b>duplicate payment</b> for review', icon: 'flag', tint: 'teal' },
]

// 14-day work chart — created vs. saved (relative heights 0..1)
export const chartData = [
  { d: 'W1', created: 0.42, saved: 0.30 },
  { d: 'W2', created: 0.55, saved: 0.40 },
  { d: 'W3', created: 0.61, saved: 0.52 },
  { d: 'W4', created: 0.70, saved: 0.58 },
  { d: 'W5', created: 0.78, saved: 0.66 },
  { d: 'W6', created: 0.88, saved: 0.74 },
  { d: 'Now', created: 1.0, saved: 0.86 },
]

export const tintMap = {
  coral: { bg: 'var(--coral-50)', fg: 'var(--coral-500)', solid: 'var(--coral-400)' },
  teal: { bg: 'var(--teal-50)', fg: 'var(--teal-500)', solid: 'var(--teal-400)' },
  lav: { bg: 'var(--lav-50)', fg: 'var(--lav-400)', solid: 'var(--lav-300)' },
  peach: { bg: 'var(--peach-50)', fg: 'var(--peach-fg)', solid: 'var(--peach-300)' },
}
